export enum PlayerFormat {
  Horizontal = "horizontal",
  Vertical = "vertical",
  Auto = "auto",
}
